/**
 * KB Adapter
 * Authority: ADAPTER AGENT (Stability V2)
 */
import { getContractDefaults } from '../contracts/render_contracts';

export const adaptKB = (raw) => {
    const d = getContractDefaults('KBItem');
    if (!raw) return d;

    return {
        ...d,
        id: raw.id || raw._id || "",
        display_name: raw.title || d.display_name,
        summary: raw.summary || d.summary,
        score: typeof raw.score === 'number' ? raw.score : d.score,
        recommendation: raw.recommendation || d.recommendation,
        date_label: raw.date ? new Date(raw.date).toLocaleDateString() : d.date_label,
        status_label: raw.status || d.status_label
    };
};

/**
 * Legall legacy adapter from readViewSchemas
 */
export const adaptKBEntry = (entry) => ({
    ...entry,
    title: entry.title || entry.name || 'Untitled'
});
